import { render } from "./StartAppComponent.vue?vue&type=template&id=de2b0092&scoped=true"
import script from "./StartAppComponent.vue?vue&type=script&lang=js"
export * from "./StartAppComponent.vue?vue&type=script&lang=js"

import "./StartAppComponent.vue?vue&type=style&index=0&id=de2b0092&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de2b0092"]])

export default __exports__